export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST'
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL'
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS'

export const USER_REFRESH_TOKEN_REQUEST = 'USER_REFRESH_TOKEN_REQUEST'
export const USER_REFRESH_TOKEN_FAIL = 'USER_REFRESH_TOKEN_FAIL'
export const USER_REFRESH_TOKEN_SUCCESS = 'USER_REFRESH_TOKEN_SUCCESS'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'

export const USER_UPDATE_PASSWORD_REQUEST = 'USER_UPDATE_PASSWORD_REQUEST'
export const USER_UPDATE_PASSWORD_FAIL = 'USER_UPDATE_PASSWORD_FAIL'
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS'

export const GET_MY_PROFILE_REQUEST = 'GET_MY_PROFILE_REQUEST'
export const GET_MY_PROFILE_FAIL = 'GET_MY_PROFILE_FAIL'
export const GET_MY_PROFILE_SUCCESS = 'GET_MY_PROFILE_SUCCESS'
